let steps = {1:"/",2:"/volo",3:"/infopersonali",4:"/conferma",5:"/conclusione",6:"/psgsubcomplete"};

function ultimoStep(stepcompletati){
    if(stepcompletati.length < 1) return 0;
    return Math.max.apply(null,stepcompletati);
}

function verificaStep(stepcompletati){
    let ultimostep = ultimoStep(stepcompletati);
    switch(ultimostep){
        case 0:
            return {step  :1, url: steps["1"] }
        case 1:
            return { step :2, url: steps["2"] }
        case 2:
            return { step :3, url: steps["3"] }
        case 3:
            return { step: 4, url: steps["4"] }
        case 4:
            return { step: 5, url: steps["5"] }
        case 5:
            return { step: 5, url: steps["5"] }
        case 6:
            return { step: 6, url: steps["6"] }
        default:
            return null;
    }
}

export { verificaStep };